export default __webpack_public_path__ + "static/media/WD-58GM 58mm mini bluetooth portable printer.9ebb7581.jpg";